module.exports = {
  SQUARE: 'square',
  VEND: 'vend',
  FRESHA: 'fresha',
  ALTEGIO: 'altegio',
  PACT: 'pact',
  MESSENGER: 'messenger'
}
